import { apiClient } from '@/shared/api/client'

export async function getCustomers(params = {}) {
  const response = await apiClient.get('/customers', { params })
  return response.data
}

export async function getCustomerById(id) {
  const response = await apiClient.get(`/customers/${id}`)
  return response.data
}

export async function createCustomer(payload) {
  const response = await apiClient.post('/customers', payload)
  return response.data
}

export async function updateCustomer(id, payload) {
  const response = await apiClient.put(`/customers/${id}`, payload)
  return response.data
}

export const deleteCustomer = async (id) => {
  const response = await apiClient.delete(`/customers/${id}`)
  return response.data
}

export async function bulkUploadCustomers(file) {
  const formData = new FormData()
  formData.append('file', file)
  const response = await apiClient.post('/customers/bulk-upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}
